(() => {
  const preferenceKey = 'yfl-localization-preference-v1';
  const detectionKey = 'yfl-localization-detection-pending-v1';
  const navigationKey = 'yfl-localization-navigation-pending-v1';
  const supportedLanguages = new Set(['en', 'sv', 'de', 'fr', 'es', 'da', 'nb', 'nl', 'it', 'pl']);

  const getStoredPreference = () => {
    try {
      return window.localStorage.getItem(preferenceKey);
    } catch (error) {
      return null;
    }
  };

  const storePreference = (value) => {
    try {
      window.localStorage.setItem(preferenceKey, value);
    } catch (error) {
      // Localization still works when storage is unavailable.
    }
  };

  const setDetectionPending = (isPending) => {
    try {
      if (isPending) {
        window.sessionStorage.setItem(detectionKey, 'true');
      } else {
        window.sessionStorage.removeItem(detectionKey);
      }
    } catch (error) {
      // Continue without a session-level duplicate-request guard.
    }
  };

  const isDetectionPending = () => {
    try {
      return window.sessionStorage.getItem(detectionKey) === 'true';
    } catch (error) {
      return false;
    }
  };

  const markManual = () => storePreference('manual');
  const markNavigation = () => {
    try {
      window.sessionStorage.setItem(navigationKey, String(Date.now()));
    } catch (error) {
      // The language change still works when session storage is unavailable.
    }
  };
  window.YflLocalization = { markManual, markNavigation };

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (form instanceof HTMLFormElement && form.action.includes('/localization')) {
        markManual();
        markNavigation();
      }
    },
    true
  );

  document.addEventListener(
    'click',
    (event) => {
      if (
        event.target instanceof Element &&
        event.target.closest('localization-form, .yfl-preview-language-switcher')
      ) {
        markManual();
      }
    },
    true
  );

  const detectLocalization = async () => {
    const form = document.getElementById('YflLocalizationAutodetect');
    if (!form || window.Shopify?.designMode || getStoredPreference() || isDetectionPending()) return;

    const countryInput = form.querySelector('input[name="country_code"]');
    const localeInput = form.querySelector('input[name="locale_code"]');
    if (!countryInput || !localeInput || !window.Shopify?.routes?.root) return;

    setDetectionPending(true);

    try {
      const currentCountry = window.Shopify.country || countryInput.value;
      const currentLanguage = window.Shopify.language || localeInput.value;
      const query = new URLSearchParams({
        'country[enabled]': 'true',
        'country[exclude]': currentCountry,
        'language[enabled]': 'true',
        'language[exclude]': currentLanguage,
      });
      const response = await fetch(
        `${window.Shopify.routes.root}browsing_context_suggestions.json?${query.toString()}`,
        { credentials: 'same-origin' }
      );

      if (!response.ok) throw new Error(`Localization suggestion failed: ${response.status}`);

      const result = await response.json();
      const suggestion = result.suggestions?.[0]?.parts || {};
      const detectedCountry = suggestion.country?.handle || currentCountry;
      let detectedLanguage = suggestion.language?.handle || currentLanguage;

      if (detectedCountry === 'SE') {
        detectedLanguage = 'sv';
      } else if (detectedCountry === 'NO') {
        detectedLanguage = 'nb';
      } else if (detectedCountry === 'GB') {
        detectedLanguage = 'en';
      } else if (detectedCountry === 'DE') {
        detectedLanguage = 'de';
      } else if (!supportedLanguages.has(detectedLanguage)) {
        detectedLanguage = 'en';
      }

      storePreference(`detected:${detectedCountry}:${detectedLanguage}`);

      if (detectedCountry === currentCountry && detectedLanguage === currentLanguage) return;

      countryInput.value = detectedCountry;
      localeInput.value = detectedLanguage;
      markNavigation();
      form.submit();
    } catch (error) {
      // A temporary detection failure should not block the storefront or a
      // later retry. Manual selectors remain fully functional.
    } finally {
      setDetectionPending(false);
    }
  };

  detectLocalization();
})();
